module.exports = __webpack_public_path__ + "static/media/shoes4.f97ffa73.jpg";